<template>
  <li
    class="push-card"
  >
    <router-link
      class="push-card--content"
      :class="`decors-background-${push.bg}`"
      :to="push.to"
    />
    <div class="push-card--icon decors-background-push-coin-gauche">
      <div class="after">
        <div
          class="icon"
          :class="`decors-icons-${push.icon}`"
        />
        <div class="label">
          {{ push.label }}
        </div>
      </div>
    </div>
  </li>
</template>

<script>
export default {
  name: 'PushCard',
  props: {
    push: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="stylus" scoped>
.push-card {
  list-style: none;
  position relative;
  width: fit-content;
  overflow: hidden;
  flex-shrink: 1;
  cursor: pointer
  border-bottom-left-radius: 33px;
  max-width: 100%;

  &:hover {
      .icon {
        transform: translateX(5px);
      }
      .label {
        transform: translateX(15px);
      }
    .push-card--content {
      transform: scale(1.1);
      filter: brightness(1.1);
    }
  }

  &--content {
    border-bottom-left-radius: 33px;
    display: block;
    transition: all 0.3s ease-out;
    width: 100%;
    height: 202px;
  }

  &--icon {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    pointer-events: none;

    .after {
      position: absolute;
      bottom: 15px;
      left: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 15px;

      .icon {
        transition: transform 0.3s ease-out;
      }

      .label {
        font-size: 1.5rem;
        font-weight: bold;
        color: white
        background-color: rgba(0, 0, 0, 0.9);
        width: fit-content;
        font-size: 24px;
        font-weight: 700;
        text-transform: uppercase;
        padding: 4px 10px;
        border-radius: 3px;
        transition: transform 0.3s ease-out;
      }
    }
  }
}
</style>
